module.exports = __webpack_public_path__ + "images/main_page_mock_preview.webp";